import { Fragment } from 'react';

import { EmployeeCountOption } from '../schedule-demo-wizard';

type StepWelcomeProps = {
  copy: string
  onEmployeeCountSelect: (value: EmployeeCountOption) => void
  title: string
}

const StepWelcome = (props:StepWelcomeProps) => {

  const handleScheduleCallClick = (employeeCount: EmployeeCountOption) => {
    window.posthog?.capture('Click to schedule a sales call');
    props.onEmployeeCountSelect(employeeCount);
  };
  
  return <Fragment>
    <h1 className="schedule-demo-wizard--title">{props.title}</h1>
    <p className="schedule-demo-wizard--copy">{props.copy}</p>

    <p className="schedule-demo-wizard--how-many-employees-text"><strong>How many employees do you schedule?</strong></p>
    <div className="schedule-demo-wizard--employee-count-selection">
      <div className="employee-count-selection">
        <div className="employee-count-selection-buttons">
          <button
            className="button is-rounded green-pill-button"
            onClick={ () => props.onEmployeeCountSelect(EmployeeCountOption.SMALL_BUSINESS) }
            type="button"
          >
            {EmployeeCountOption.SMALL_BUSINESS}
          </button>
          <button
            className="button is-rounded green-pill-button"
            onClick={ () => handleScheduleCallClick(EmployeeCountOption.MEDIUM_BUSINESS) }
            type="button"
          >
            {EmployeeCountOption.MEDIUM_BUSINESS}
          </button>
          <button
            className="button is-rounded green-pill-button"
            onClick={ () => handleScheduleCallClick(EmployeeCountOption.LARGE_BUSINESS) }
            type="button"
          >
            {EmployeeCountOption.LARGE_BUSINESS}
          </button>
        </div>
      </div>
    </div>
  </Fragment>;
};


export default StepWelcome;
